import { Plus, Bug, Lightbulb, ListTodo } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface TaskData {
  id: string;
  type: string;
  description: string;
  status: string;
}

interface TaskAddedWidgetProps {
  data: TaskData;
}

const typeConfig: Record<string, { icon: typeof ListTodo; color: string; badge: string }> = {
  bug:  { icon: Bug,       color: "text-intri-error",  badge: "error" },
  idea: { icon: Lightbulb, color: "text-intri-info",   badge: "info" },
  task: { icon: ListTodo,  color: "text-intri-accent", badge: "accent" },
};

export function TaskAddedWidget({ data }: TaskAddedWidgetProps) {
  if (!data) return null;
  const config = typeConfig[data.type] ?? typeConfig.task!;
  const Icon = config!.icon;

  return (
    <Card variant="default" padding="sm" className="max-w-md animate-slide-up">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center h-8 w-8 rounded-lg bg-intri-accent-ghost">
          <Plus size={14} className="text-intri-accent" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <Icon size={12} className={cn("shrink-0", config.color)} />
            <Badge variant={config!.badge as "accent" | "error" | "info"} size="sm">
              {data.type}
            </Badge>
          </div>
          <p className="text-sm text-intri-text mt-1 leading-snug">{data.description}</p>
        </div>
      </div>
    </Card>
  );
}
